import React from "react";

const CheckCircleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={17}
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      fill="currentColor"
      d="M8 15.5a7 7 0 1 1 0-14 7 7 0 0 1 0 14Zm0 1a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"
    />
    <path
      fill="currentColor"
      d="M10.97 5.47a.235.235 0 0 0-.02.022L7.477 9.917 5.384 7.823a.75.75 0 0 0-1.06 1.06L6.97 11.53a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05Z"
    />
  </svg>
);

export default CheckCircleIcon;
